/**
 * Hook to fetch config items from DB via /configs/:code/items
 * Used by ConfigPrefetcher to populate the status-registry DB cache.
 */

import { useQuery } from '@tanstack/react-query';
import { configsApi } from '@/lib/api-client';

/** Fetch all categories with items (for app-wide prefetch) */
export function useAllConfigCategories() {
  return useQuery({
    queryKey: ['config-categories-all'],
    queryFn: async () => {
      const res = await configsApi.getCategories();
      return res?.data ?? [];
    },
    staleTime: 5 * 60 * 1000, // 5 mins
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
  });
}

/** Fetch items for a single category */
export function useConfigItems(categoryCode: string) {
  return useQuery({
    queryKey: ['config-items', categoryCode],
    queryFn: async () => {
      const res = await configsApi.getItems(categoryCode);
      return res?.data ?? [];
    },
    staleTime: 5 * 60 * 1000, // 5 mins
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
    enabled: !!categoryCode,
  });
}
